var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "f00b6af7662bd3e963834b7f2a0cb82b.png",
    width: 90,
    height: 90
});